import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { apiClient } from '@/lib/api';
import { NEWSLETTER_ENDPOINTS } from '@/features/noticias/api/endpoints';
import type { NewsletterFormData } from '@/features/noticias/schemas/newsletter.schema';

interface SuscribirNewsletterResponse {
  success: boolean;
  message: string;
}

export function useSuscribirNewsletterMutation(): UseMutationResult<
  SuscribirNewsletterResponse,
  Error,
  NewsletterFormData
> {
  return useMutation({
    mutationFn: (data: NewsletterFormData) =>
      apiClient<SuscribirNewsletterResponse>(NEWSLETTER_ENDPOINTS.SUSCRIBIR, {
        method: 'POST',
        body: data,
      }),
  });
}
